interface InitData {
  routerName: string
}

export const getInitData = <T = InitData>(): T => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const data = window.__INITIAL_DATA__
  return (data ? data : { routerName: '' }) as T
}
